import { Observable } from "rxjs";
import { BleClient, ScanResult } from "@capacitor-community/bluetooth-le";
import { resetNotificationStreams } from "@/features/ble/utils/getDeviceNotificationsStream.tsx";
import { resetSequences } from "@/features/ble/utils/sendCommand.ts";
import { variant } from "@/core/variant.ts";
import i18n from "@/core/i18n.ts";

/**
 * An observable that emits scan results
 * and completes after the specified duration.
 * @param scanDurationMs
 */
export const requestLEScan = (scanDurationMs = 4000) =>
  new Observable<ScanResult>((subscriber) => {
    const scan = async () => {
      try {
        await BleClient.initialize({ androidNeverForLocation: true });
        if (!(await BleClient.isEnabled())) {
          try {
            await BleClient.requestEnable();
          } catch {
            // requestEnable is not supported on iOS
          }
          if (!(await BleClient.isEnabled())) {
            throw new Error(i18n.global.t("BleBluetoothDisabledError"));
          }
        }
        await Promise.all(
          (
            await BleClient.getConnectedDevices([])
          ).map((device) => BleClient.disconnect(device.deviceId))
        );
        resetNotificationStreams();
        resetSequences();
        await BleClient.requestLEScan(
          {
            namePrefix: variant.bleNamePrefix,
            services: [],
            allowDuplicates: false,
          },
          (result) => {
            console.log("new result", result);
            subscriber.next(result);
          }
        );
        setTimeout(async () => {
          await BleClient.stopLEScan();
          subscriber.complete();
        }, scanDurationMs);
      } catch (error) {
        subscriber.error(error);
      }
    };

    scan();
  });
